<template>
  <div class="distribution-bd">
    <div class="tab-box">
      <el-tabs v-model="active">
        <el-tab-pane v-if="funcView.organ_user_list" :label="$t('distribution.bu_men_yuan_gong')" name="member"></el-tab-pane>
        <el-tab-pane v-if="funcView.location_tag_list" :label="$t('distribution.xiang_mu_qu_yu')" name="location"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 部门/员工 -->
    <distribution-member v-if="active == 'member'"></distribution-member>
    <!-- 项目/区域 -->
    <distribution-location v-if="active == 'location'" :propsLocationId="locationId" :propsSiteId="siteId"></distribution-location>
  </div>
</template>

<script>
import distributionMember from './distribution_member.vue';
import distributionLocation from './distribution_location.vue';

export default {
  name: 'distribution',
  components: { distributionMember, distributionLocation },
  data() {
    return {
      active: '',
      locationId: '',
      siteId: '',
    };
  },
  mounted: function () {
    this.locationId = this.getJump('locationId');
    this.siteId = this.getJump('siteId');
    this.getFuncView(null, () => {
      if (this.funcView.organ_user_list) {
        this.active = this.getJump('active') || 'member';
      } else if (this.funcView.location_tag_list) {
        this.active = this.getJump('active') || 'location';
      }
    });
  },
  methods: {},
};
</script>

<style lang="scss">
@import '@/style/colors.scss';

.distribution-bd {
  padding-left: 24px;
  padding-right: 24px;
  .tab-box {
    padding-top: 24px 0;
  }
}
</style>
